import { DraftReturnItemAction } from '../draft-return/draft-return.model';

export enum ReturnReasonAction {
  Refund = 'Refund',
  Exchange = 'Exchange',
  Other = 'Other',
}

export enum ReturnLabelType {
  Image = 'image/png',
  PDF = 'application/pdf',
}

export enum CycleonReturnOrderStatusEnum {
  DRAFT = 'DRAFT',
  PENDING_PAYMENT = 'PENDING_PAYMENT',
  PAYMENT_FAILED = 'PAYMENT_FAILED',
  PENDING_LABEL = 'PENDING_LABEL',
  DONE = 'DONE',
  CANCELLED = 'CANCELLED',
  REFUNDED = 'REFUNDED',
}

export type CurrencyAmountType = {
  amount: number;
  currency: string;
};

export type FilterReturnOrderParams = {
  paymentReference?: string;
  returnOrderId?: string;
};

export enum CycleonFilterParameter {
  RETURN_ORDER_ID = 'returnOrderId',
  PAYMENT_REFERENCE = 'paymentReference',
}

export type ReturnReason = {
  action: ReturnReasonAction;
  reason: string;
  reasonCategory: string;
  wish: string;
  additional: {
    title: string;
    value: string;
  };
};

export type ReturnItem = {
  cycleonId: string | null;
  skuCode: string;
  skuDesc: string;
  quantity: number;
  price: number;
  costPrice: number;
  weight: number;
  weightUom: string;
  length: number;
  width: number;
  height: number;
  dimensionsUom: string;
  hsCode: string;
  countryCode: string;
  imgPath: string;
  dangerousGoods: string;
  tracking: string;
  exportDate: string;
  exportAwb: string;
  exportCarrierName: string;
  skuUrl: string;
  nonReturnable: boolean;
  daysForReturn: string;
  finalDestName: string;
  finalDestCompanyName: string;
  finalDestId: string;
  finalDestCountry: string;
  finalDestState: string;
  finalDestZip: string;
  finalDestCity: string;
  finalDestAddr1: string;
  finalDestAddr2: string;
  finalDestAddr3: string;
  finalDestNeighborhood: string;
  finalDestSuburb: string;
  verificationEntity: string;
  finalDisposition: string;
  reason: ReturnReason[];
  returnType: DraftReturnItemAction;
  exchangeItemSku: string;
  storeCreditRefund: CurrencyAmountType;
  clientMetadata: Record<string, string>;
};

export type Return = {
  id: string;
  orderReference: string;
  dateAdded: Date | number;
  name: string;
  companyName: string;
  zip: string;
  email: string;
  addr1: string;
  addr2: string;
  addr3: string;
  city: string;
  state: string;
  country: string;
  phone: string;
  displayId: string;
  externalId: string;
  finalDestAddr1: string;
  finalDestAddr2: string;
  finalDestAddr3: string;
  finalDestCity: string;
  finalDestCountry: string;
  finalDestState: string;
  finalDestZip: string;
  finalDestName: string;
  finalDestCompanyName: string;
  finalDestId?: string;
  tracking: string;
  trackingLastUpdate: string;
  currentTrackingStatus: string;
  verificationEntity: string;
  barcodeNumber: string;
  carrier: string;
  label: string;
  labelType: ReturnLabelType | string;
  carrierName: string;
  currencyCode: string;
  refundValue: number;
  status: string;
  items: ReturnItem[];
  trackingHistory: TrackingHistoryItem[];
};

export type TrackingHistoryLocation = {
  country: string;
  state: string;
  city: string;
};

export type TrackingHistoryItem = {
  date: number;
  status: string;
  location: TrackingHistoryLocation;
};
